import { post } from '../api/api'

const recordPageTime = {
  data () {
    return {
      startTime: ''
    }
  },
  beforeMount () {
    this.startTime = new Date().getTime()
  },
  beforeRouteLeave (to, from, next) {
    const tourl = to.path
    const fromurl = from.path
    const endTime = new Date().getTime()
    const time = endTime - this.startTime
    post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl, time })
    next()
  }
}

export default recordPageTime
